define('fukit/behavior/resolve.options.behavior',['require','exports','module','marionette','underscore','backbone.radio','bluebird','appkit/appkit'],function(require, exports, module) {
  //prettier-ignore
  var Mn                  = require('marionette'),
      _                   = require('underscore'),
      Radio               = require('backbone.radio'),
      Promise             = require('bluebird'),
      KeyPrefixer         = require('appkit/appkit').util.KeyPrefixer,
      RESOLVE_OPTIONS_KEY = 'resolveOptions';

  var ResolveOptionsBehavior = Mn.Behavior.extend(
    {
      initialize: function() {
        Mn.Behavior.prototype.initialize.apply(this, arguments);
        var unresolvedOptions = this.view.getOption(RESOLVE_OPTIONS_KEY);
        _.extend(this.view.options, ResolveOptionsBehavior.resolveViewOptions(unresolvedOptions || {}, this.view));

        this.listenToOnce(this.view, 'before:render', function() {
          var resolvedOptions = ResolveOptionsBehavior.resolveViewOptions(unresolvedOptions || {}, this.view);
          _.extend(this.view.options, resolvedOptions);

          this.view.trigger('resolve:options');
        });
      },
    },
    {
      resolveViewValue: function(value, view) {
        if (_.isString(value)) {
          value = ResolveOptionsBehavior.resolveStringValueWithView(value, view);
        } else if (_.isArray(value)) {
          value = _.map(value, function(item) {
            return ResolveOptionsBehavior.resolveViewValue(item, view);
          });
        } else if (_.isObject(value) && value.constructor === Object) {
          value = ResolveOptionsBehavior.resolveViewOptions(value, view);
        }
        return value;
      },

      resolveViewOptions: function(options, view) {
        var key, value;
        var resolvedOptions = {};
        options = options || {};
        for (key in options) {
          value = options[key];
          if (key == RESOLVE_OPTIONS_KEY) {
            // skip over
          } else {
            value = ResolveOptionsBehavior.resolveViewValue(value, view);
          }
          resolvedOptions[key] = value;
        }
        return resolvedOptions;
      },

      resolveStringValueWithView: function(value, view) {
        if (KeyPrefixer.hasPrefix(value, '@resources.')) {
          return ResolveOptionsBehavior.getResource(KeyPrefixer.removePrefix(value, '@resources.'));
        } else if (KeyPrefixer.hasPrefix(value, '@state.')) {
          // skip over
        } else if (KeyPrefixer.hasPrefix(value, '@state')) {
          return ResolveOptionsBehavior.getState();
        } else if (KeyPrefixer.hasPrefix(value, '@this.')) {
          var key = KeyPrefixer.removePrefix(value, '@this.');
          value = view.getOption(key);
          if (_.isFunction(value)) {
            value = _.bind(value, view);
          }
          return value;
        } else if (KeyPrefixer.hasPrefix(value, '@model.')) {
          // skip over
        } else if (KeyPrefixer.hasPrefix(value, '@model')) {
          return view.getOption('model');
        } else if (KeyPrefixer.hasPrefix(value, '@collection')) {
          return view.getOption('collection');
        }
        return value;
      },
      getResource: function(resourceName) {
        var resource = Radio.request('AppKit.resourceService', 'resource', resourceName);
        if (!resource) {
          Promise.reject(new Error('The resource named "' + resourceName + '" does not exist.'));
        }
        return resource;
      },

      getState: function() {
        return Radio.request('AppKit.controllerService', 'state');
      },
    }
  );

  ResolveOptionsBehavior.RESOLVE_OPTIONS_KEY = RESOLVE_OPTIONS_KEY;

  module.exports = ResolveOptionsBehavior;
});

